"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function save(_ref) {
  let {
    attributes: {
      tagName: Tag
    }
  } = _ref;
  return (0, _element.createElement)(Tag, _blockEditor.useInnerBlocksProps.save(_blockEditor.useBlockProps.save()));
}
//# sourceMappingURL=save.js.map